<script>
export default {
    name: "ProductUpdateInitial",
    props: [ 'initial' ],
    data() {
        return {
            initialAttributes: [],
        }
    },
    methods: {
        setInitialData() {
            if(!this.initial) return false;

            if(this.initial.categoryParent) {
                this.formData.mainCategory = this.initial.categoryParent;
            }

            if(this.initial.category) {
                this.formData.category = this.initial.category;
            }

            if(this.initial.seller) {
                this.formData.seller = this.initial.seller;
            }

            if(this.initial.selfShipment) {
                this.formData.selfShipment = this.initial.selfShipment;
            }

            this.formData.productNameRu = this.initial.nameRu || null;
            this.formData.productNameUa = this.initial.nameUa || null;
            this.formData.articleNumber = this.initial.articleNumber || null;
            this.formData.initialImages = this.initial.images;

            if(this.initial.pack) {
                this.formData.packingType = {id: this.initial.pack.packID, name: this.initial.pack.packName};
                this.formData.packingQuantity = this.initial.pack.value;
                this.formData.quantityUnits = {id: this.initial.pack.unitID, name: this.initial.pack.unitName};
                this.formData.minValueQuantity = this.initial.pack.minValue || null;
                this.formData.packLength = this.initial.pack.length;
                this.formData.packWidth = this.initial.pack.width;
                this.formData.packHeight = this.initial.pack.height;
                this.formData.packWeight = this.initial.pack.weight;
            }

            if(this.initial.price) {
                this.formData.currency = {id: this.initial.price.currencyID, name: this.initial.price.currencyName};
                this.formData.price = this.initial.price.value || null;
                this.formData.withNds = this.initial.price.withNds;
                this.formData.discountPercent = this.initial.price.discount;
                this.discountPrice = (this.formData.price * (1 - this.formData.discountPercent / 100)).toFixed(2);
            }

            if(this.initial.manufacturer) {
                this.formData.manufacturer = {
                    id: this.initial.manufacturer.valueID,
                    system_name: this.initial.manufacturer.attributeSystemName,
                    name: this.initial.manufacturer.attributeName,
                };
            }

            this.initialAttributes = this.initial.attributes;

            //if(!this.initial || !this.initial.description_ru || !this.initial.description_ua) return false;

            this.formData.descriptionRu = this.initial.descriptionRu;
            this.formData.descriptionUa = this.initial.descriptionUa;

            // if(this.initial.paymentWays) {
            //     this.formData.paymentWays = this.initial.paymentWays.map(item => item.id);
            // }
        },
    },
    watch: {
        initial: {
            handler() {
                this.setInitialData();
            },
            deep: true
        },
    }
}
</script>
